import useProductDetail from "@/app/lib/features/productDetail/productDetail.hook";

const ProductSizeTable = () => {
  const { product } = useProductDetail();

  if (!product?.product_sizes_html) return null;

  const cleanHtml = product.product_sizes_html
    .replace(/<meta[^>]*>/gi, "")
    .replace(/<style[^>]*>[\s\S]*?<\/style>/gi, "");

  return (
    <div className="space-y-2 overflow-x-auto">
      <h2 className="font-medium text-sm my-4">Beden Tablosu</h2>
      <div
        className="text-sm [&_table]:w-full [&_table]:border-collapse [&_th]:bg-[#f5f5f5] [&_th]:p-2 [&_th]:border [&_th]:border-[#dee2e6] [&_td]:p-2 [&_td]:border [&_td]:border-[#dee2e6] [&_h3]:hidden [&_body]:p-0 [&_body]:m-0"
        dangerouslySetInnerHTML={{ __html: cleanHtml }}
      />
    </div>
  );
};

export default ProductSizeTable;